export default {
  LOAD_LIST(state, data) {
    state.listGrid = data
  },
}
